import { IBaseModel } from "./abstract/ibaseModel.interface";

export class BaseModel implements IBaseModel {
    id: number;

     constructor(id: number) {
        this.id = id;
     }
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/base.model.ts